module.exports = __webpack_public_path__ + "static/media/021.314e52da.jpg";